module.exports = __webpack_public_path__ + "static/media/unholy_broken_sword.44b80b78.png";